import React from "react";
import Image from "next/image";
import { type EventsPageSpeaker } from "lib/sanity";
import { Flex, Text, Box, AspectRatio, SimpleGrid } from "@chakra-ui/react";
import { Section } from "components/section";

export function EventSpeakers({ speakers }: { speakers: EventsPageSpeaker[] }) {
  return (
    <Section>
      <Text as="h2" textStyle="h5">
        Meet the speakers
      </Text>
      <SimpleGrid columns={{ base: 2, md: 3, lg: 4 }} gap={8} mt={{ base: 8, md: 12 }}>
        {speakers.filter(Boolean)?.map((speaker) => (
          <Flex key={speaker.name} direction="column" maxW="300px">
            <AspectRatio ratio={1 / 1} pos="relative" w="100%" maxW="200px">
              <Image
                fill
                src={speaker.imageUrl + "?w=400"}
                alt={`${speaker.name}.`}
                style={{
                  objectFit: "cover",
                  borderRadius: "6px",
                  border: "1px solid",
                  borderColor: "var(--chakra-colors-base-border)",
                  background: "var(--chakra-colors-base-border)",
                }}
              />
            </AspectRatio>

            <Text fontWeight="semibold" fontSize={{ base: "sm", md: "md" }} mt={3}>
              {speaker.name}
            </Text>

            <Box color="brand.textSecondary.light" fontSize={{ base: "xs", md: "sm" }} mt={1}>
              <Text>{speaker.job}</Text>
              <Text>{speaker.company}</Text>
            </Box>
          </Flex>
        ))}
      </SimpleGrid>
    </Section>
  );
}
